var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOtherSurgeriesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.738 18V9H2.73804V18H14.738ZM16.738 13V11H18.738V2H6.73804V7H4.73804V2C4.73804 1.45 4.93387 0.979167 5.32554 0.5875C5.7172 0.195833 6.18804 0 6.73804 0H18.738C19.288 0 19.7589 0.195833 20.1505 0.5875C20.5422 0.979167 20.738 1.45 20.738 2V11C20.738 11.55 20.5422 12.0208 20.1505 12.4125C19.7589 12.8042 19.288 13 18.738 13H16.738ZM2.73804 20C2.18804 20 1.7172 19.8042 1.32554 19.4125C0.93387 19.0208 0.738037 18.55 0.738037 18V9C0.738037 8.45 0.93387 7.97917 1.32554 7.5875C1.7172 7.19583 2.18804 7 2.73804 7H14.738C15.288 7 15.7589 7.19583 16.1505 7.5875C16.5422 7.97917 16.738 8.45 16.738 9V18C16.738 18.55 16.5422 19.0208 16.1505 19.4125C15.7589 19.8042 15.288 20 14.738 20H2.73804Z",
    fill: "#0288D1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherSurgeriesIcon);
export default __webpack_public_path__ + "static/media/other-surgeries-icon.ffe2e524.svg";
export { ForwardRef as ReactComponent };